module.exports = __webpack_public_path__ + "img/student_report_04.8ddafb9a.png";